import * as S from './Card.styles';
type SpacingType =
  | '0'
  | '1'
  | '2'
  | '3'
  | '4'
  | '5'
  | '6'
  | '7'
  | '8'
  | '9'
  | '10'
  | '11';

type ShadowType = '1' | '2' | '3';

type BorderRadiusType = '1' | '2' | '3' | '4' | '5';

type BorderWidthType = '1' | '2' | '3' | '4';

type CardProps = {
  spacing?:
    | SpacingType
    | {
        top?: SpacingType;
        left?: SpacingType;
        right?: SpacingType;
        bottom?: SpacingType;
      };
  boxShadow?: boolean | ShadowType;
  border?: boolean;
  borderWidth?: BorderWidthType;
  disabled?: boolean;
  pressed?: boolean;
  borderRadius?:
    | boolean
    | {
        topLeft?: boolean;
        topRight?: boolean;
        bottomLeft?: boolean;
        bottomRight?: boolean;
      };
  borderRadiusAmount: BorderRadiusType;
  onClick?: () => void;
  variant:
    | 'none'
    | 'primary'
    | 'neutral'
    | 'secondary-1'
    | 'warning'
    | 'info'
    | 'success'
    | 'empty'
    | 'danger'
  modifier: 'regular' | 'weak' | 'inverted';
  children?: any;
  width?: string;
  maxWidth?: string;
  height?: string;
  margin?:
    | SpacingType
    | {
        top?: SpacingType;
        left?: SpacingType;
        right?: SpacingType;
        bottom?: SpacingType;
      }
    | string;
  display?: string;
  gap: string;
  justifyContent:
    | 'none'
    | 'center'
    | 'flex-start'
    | 'flex-end'
    | 'space-between';
  justifyItems: 'none' | 'center' | 'flex-start' | 'flex-end' | 'space-between';
  alignItems:
    | 'inherit'
    | 'center'
    | 'flex-start'
    | 'flex-end'
    | 'right'
    | 'end'
    | 'baseline';
  flexWrap: 'nowrap' | 'wrap';
  flexDirection?: 'row' | 'column' | 'row-reverse' | 'column-reverse';
  contain?: string;
  withElevation: boolean;
  style?: React.CSSProperties;
};

const defaultProps = {
  spacing: '0',
  boxShadow: false,
  border: false,
  borderWidth: '2',
  disabled: false,
  pressed: false,
  borderRadius: true,
  borderRadiusAmount: '3',
  variant: 'none',
  modifier: 'weak',
  width: 'auto',
  maxWidth: 'auto',
  height: 'auto',
  margin: 'none',
  display: 'block',
  gap: '0px',
  justifyContent: 'none',
  justifyItems: 'none',
  alignItems: 'inherit',
  flexWrap: 'nowrap',
  withElevation: false
};
const Card = (props: CardProps) => {
  const {
    spacing,
    boxShadow,
    border,
    borderWidth,
    disabled,
    pressed,
    borderRadius,
    borderRadiusAmount,
    variant,
    modifier,
    width,
    maxWidth,
    height,
    margin,
    display,
    gap,
    justifyContent,
    justifyItems,
    alignItems,
    flexWrap,
    flexDirection,
    contain,
    withElevation,
    style
  } = props;
  return (
    <S.Card
      borderRadius={borderRadius}
      borderRadiusAmount={borderRadiusAmount}
      spacing={spacing}
      boxShadow={boxShadow}
      border={border}
      borderWidth={borderWidth}
      disabled={disabled}
      onClick={props.onClick}
      pressed={pressed}
      hasCursorPointer={props.onClick && true}
      variant={variant}
      modifier={modifier}
      width={width}
      maxWidth={maxWidth}
      height={height}
      margin={margin}
      display={display}
      gap={gap}
      justifyContent={justifyContent}
      justifyItems={justifyItems}
      alignItems={alignItems}
      flexWrap={flexWrap}
      flexDirection={flexDirection}
      contain={contain}
      withElevation={withElevation}
      style={style}
    >
      {props.children}
    </S.Card>
  );
};

Card.defaultProps = defaultProps;
export default Card;
